import { render, staticRenderFns } from "./bookPick.vue?vue&type=template&id=3810b1c9&scoped=true&"
import script from "./bookPick.vue?vue&type=script&lang=js&"
export * from "./bookPick.vue?vue&type=script&lang=js&"
import style0 from "./bookPick.vue?vue&type=style&index=0&id=3810b1c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3810b1c9",
  null
  
)

export default component.exports